export class UpdatePendingDiscountRequest {
    startDate: Date;
    endDate: Date;
    redemptionLimit: number;
    value: string;
    discountId: number;
}